import React from 'react';
import './Onas.styles.scss';

const Onas = () => {

    return (
        <div className='onas-wrapper' id='onas'>
            <div className='back-img-top'></div>
            <div className='container'>
                <div className='onas-container'>
                    <div className="img-cleaning-woman"></div>
                    <div className="oNasInformation">
                        <h3 className='onas-title'>О нас</h3>
                        <ul className="oNasText">
                            <li>Мы предоставляем все необходимые высококачественные чистящие средства и оборудование;</li>
                            <li>Вам не нужно предоставлять собственный пылесос или химию;</li>
                            <li>Вы сразу видите окончательную цену;</li>
                            <li>Оплата наличными или картой после завершения услуги;</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='back-img-bottom'></div>
        </div>
    );
};

export default Onas;